export default __webpack_public_path__ + "static/media/avatar5.036c949b.png";